module.exports = __webpack_public_path__ + "img/oog_ohowol.ebe294e4.png";